import React, { type ReactNode } from 'react'
import cn from 'classnames'
import { InstructorFaceStack } from '@mc/growth'
import { useShowFaceStack } from '../../hooks/useShowFaceStack'
import classes from './HeadlineWrapper.module.scss'

interface HeadlineWrapperProps {
  children: ReactNode
  view: 'desktop' | 'mobile'
}

export const HeadlineWrapper = ({ children, view }: HeadlineWrapperProps) => {
  const showFaceStack = useShowFaceStack()

  if (!showFaceStack) {
    return <>{children}</>
  }

  return (
    <div className={cn('d-flex align-items-center', classes[view])}>
      <InstructorFaceStack className={classes.faceStack} />
      {children}
    </div>
  )
}
